import http from './http'

/**
 * 图库列表（unite49）
 * @param {number} lotteryType 香港 1，澳门 2
 */
export function fetchUnite49PictureList(lotteryType, page = 1, pageSize = 20) {
  return http.get('/api/pictures/unite49/list', {
    params: { lotteryType, page, pageSize }
  })
}

export function fetchPictureList(params) {
  return http.get('/api/pictures/list', { params })
}
